module.exports = __webpack_public_path__ + "img/info.4502e8bb.svg";